module.exports = "https://static.energy5.com/_next/static/images/perfect1-d54049de956ea973fc1caf0249d3ba57.png";